import type { CompanionReaction, ReactionTrigger } from "./model/companion-reaction";

/**
 * トリガーに対応する声かけを表から引く（design.md「表を引くだけで決まる」構造）。
 * 教材（`LevelStory.companionReactions`）に該当トリガーの声かけが無ければ`undefined`を返す
 * （声をかけない、が正しい振る舞い。フォールバック文言は持たない）。
 *
 * 同じトリガーの声かけは教材に複数置いてよく、`occurrence`（その場面が何度目か）で
 * 順に巡回して出し分ける。同じ場面で毎回同じ台詞を返さないための仕組みであり、
 * 表を引くだけという性質は変えない（乱数も状態も持たない純関数のまま）。
 */
export function findCompanionReaction(
  reactions: readonly CompanionReaction[],
  trigger: ReactionTrigger,
  occurrence = 0,
): CompanionReaction | undefined {
  const candidates = reactions.filter((reaction) => reaction.trigger === trigger);
  if (candidates.length === 0) {
    return undefined;
  }
  return candidates[occurrence % candidates.length];
}
